/**
 * Vimeo player
 */
class VimeoPlayer {
    /**
     * Construct.
     * @param el
     */
    constructor(el) {
        const iframe = document.createElement('iframe');
        iframe.src = el.href;
        el.parentNode.classList.add('video');

        el.addEventListener('click', e => {
            e.preventDefault();
            el.parentNode.replaceChild(iframe, el);
        });
    }
}

export default VimeoPlayer;
